module.exports = __webpack_public_path__ + "img/tjx_11.a5ee4b19.png";